var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CACHE_TIME, STALE_TIME } from "../ApiProvider";
import { api } from "./api";
// Query keys
var USE_RETRIEVE_VENUE = "useRetrieveVenue";
var USE_RETRIEVE_VENUE_BY_GOOGLE_PLACE_ID = "useRetrieveVenueByGooglePlaceId";
var USE_AUTOCOMPLETE_VENUES = "useAutocompleteVenues";
var USE_SEARCH_VENUES = "useSearchVenues";
export var useRetrieveVenue = function (_a) {
    var id = _a.id, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_VENUE, id],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/venues/".concat(id, "/"))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!id && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
        onError: function (error) {
            console.error("Failed to fetch venue", error);
        },
    });
};
export var useRetrieveVenueByGooglePlaceId = function (_a) {
    var googlePlaceId = _a.googlePlaceId, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_RETRIEVE_VENUE_BY_GOOGLE_PLACE_ID, googlePlaceId],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/venues/by-google-place-id/", {
                            params: { google_place_id: googlePlaceId },
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!googlePlaceId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
        onError: function (error) {
            console.error("Failed to fetch venue by Google Place ID", error);
        },
    });
};
export var useAutocompleteVenues = function (_a) {
    var query = _a.query, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    return useQuery({
        queryKey: [USE_AUTOCOMPLETE_VENUES, query],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get("/venues/autocomplete/", {
                            params: { query: query },
                        })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: !!query && query.trim().length > 0 && enabled,
        staleTime: 30000, // Shorter stale time for autocomplete
        cacheTime: 60000, // Shorter cache time for autocomplete
        onError: function (error) {
            console.error("Failed to autocomplete venues", error);
        },
    });
};
export var useSearchVenues = function (_a) {
    var query = _a.query, lat = _a.lat, lng = _a.lng, radius = _a.radius, _b = _a.ordering, ordering = _b === void 0 ? "relevance" : _b, _c = _a.enabled, enabled = _c === void 0 ? true : _c;
    return useQuery({
        queryKey: [USE_SEARCH_VENUES, query, lat, lng, radius, ordering],
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var params, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {};
                        if (query)
                            params.q = query;
                        if (lat !== undefined)
                            params.lat = lat;
                        if (lng !== undefined)
                            params.lng = lng;
                        if (radius !== undefined)
                            params.radius = radius;
                        if (ordering)
                            params.ordering = ordering;
                        return [4 /*yield*/, api.get("/search/venues/", { params: params })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); },
        enabled: enabled,
        staleTime: 30000,
        cacheTime: 60000,
        onError: function (error) {
            console.error("Failed to search venues", error);
        },
    });
};
export var useCreateVenue = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (venueData) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post("/venues/", venueData)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); },
        onMutate: function (data) {
            onMutate === null || onMutate === void 0 ? void 0 : onMutate(data);
        },
        onSuccess: function (data) {
            // Invalidate venue-related queries
            queryClient.invalidateQueries([USE_RETRIEVE_VENUE]);
            queryClient.invalidateQueries([USE_RETRIEVE_VENUE_BY_GOOGLE_PLACE_ID]);
            queryClient.invalidateQueries([USE_SEARCH_VENUES]);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
        },
        onError: function (error) {
            console.error("Failed to create venue", error);
            onError === null || onError === void 0 ? void 0 : onError(error);
        },
    });
};
export var useUpdateVenue = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
            var id = _b.id, venueData = _b.venueData;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, api.put("/venues/manage/".concat(id, "/"), venueData)];
                    case 1: return [2 /*return*/, _c.sent()];
                }
            });
        }); },
        onMutate: function (data) {
            onMutate === null || onMutate === void 0 ? void 0 : onMutate(data);
        },
        onSuccess: function (data, variables) {
            // Invalidate and update specific venue queries
            queryClient.invalidateQueries([USE_RETRIEVE_VENUE, variables.id]);
            queryClient.invalidateQueries([USE_RETRIEVE_VENUE]);
            queryClient.invalidateQueries([USE_RETRIEVE_VENUE_BY_GOOGLE_PLACE_ID]);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
        },
        onError: function (error) {
            console.error("Failed to update venue", error);
            onError === null || onError === void 0 ? void 0 : onError(error);
        },
    });
};
export var useDeleteVenue = function (_a) {
    var onMutate = _a.onMutate, onSuccess = _a.onSuccess, onError = _a.onError;
    var queryClient = useQueryClient();
    return useMutation({
        mutationFn: function (id) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.delete("/venues/manage/".concat(id, "/"))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        onMutate: function (id) {
            onMutate === null || onMutate === void 0 ? void 0 : onMutate(id);
        },
        onSuccess: function (data, id) {
            // Invalidate venue-related queries
            queryClient.invalidateQueries([USE_RETRIEVE_VENUE, id]);
            queryClient.invalidateQueries([USE_RETRIEVE_VENUE]);
            queryClient.invalidateQueries([USE_RETRIEVE_VENUE_BY_GOOGLE_PLACE_ID]);
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        },
        onError: function (error) {
            console.error("Failed to delete venue", error);
            onError === null || onError === void 0 ? void 0 : onError(error);
        },
    });
};
